export default __webpack_public_path__ + "static/media/ipl_1.dbd4843a.png";